import React from "react";
import { TaskRateType } from "~/gql/types";
import { ImageUploadWrapper } from "~/components/ImageUploadWrapper";
import { Action } from "./stateMachine";

type TrainingUploadProps = {
  rateType: TaskRateType | null;
  trainingUploadUrl: string | null;
  dispatch: React.Dispatch<Action>;
  isEdit?: boolean;
};

export const TrainingUpload: React.FC<TrainingUploadProps> = ({
  rateType,
  trainingUploadUrl,
  dispatch,
  isEdit,
}) => {
  if (rateType !== TaskRateType.Training) {
    return null;
  }

  return (
    <ImageUploadWrapper
      label="Training Screenshot/Certificate/Etc."
      formField="trainingUploadFile"
      imageUrl={trainingUploadUrl}
      setImageUrl={(url) =>
        dispatch({
          tag: "UpdateField",
          fieldName: "trainingUploadUrl",
          value: url,
        })
      }
      setImageId={(id) =>
        dispatch({
          tag: "UpdateField",
          fieldName: "trainingUploadImageId",
          value: id,
        })
      }
      required={!isEdit}
    />
  );
};
